import { statisticsApi } from '@/core/api/statistics'

export const {
  useGetConsultationsStatisticsQuery,
  useGetEstablishmentConsultationsStatisticsQuery,
  useGetEstablishmentPatientsStatisticsQuery,
  useGetEstablishmentConsultationRankingQuery,
  useGetEstablishmentExpertiseRankingQuery,
  useGetEstablishmentExpertiseStatusStatisticsQuery,
  useGetEstablishmentDurationMetricsQuery,
  useGetEstablishmentAIUsageStatisticsQuery,
  useGetEstablishmentEntityEvolutionQuery,
  useGetReportGeneralAttendanceQuery,
  useGetReportTestsPerformedQuery,
  useGetReportThresholdAlertsQuery,
  useGetReportMaternityAttendanceQuery,
  useGetReportMissingExamsQuery,
} = statisticsApi
